<template>
  <div class="page page-map">
    <div class="container is-paddingless">
      <div class="map-container">
        <l-map ref="map" :zoom="8" :center="[42.5, -8]">
          <l-control-layers name="lControlLayers" position="topright" />
          <l-tile-layer
            v-for="tmsLayer in tmsLayers"
            :key="tmsLayer.name"
            :name="tmsLayer.name"
            :url="tmsLayer.url"
            :visible="tmsLayer.visible"
            :attribution="tmsLayer.attribution"
            layer-type="base"
          />
          <l-marker
            ref="markers"
            :lat-lng="marker.coords"
            v-for="marker in markers"
            :key="marker.id"
          >
            <l-popup>
              <h3 class="is-size-5">{{ marker.title }}</h3>
              <br />
              <button
                class="button is-primary is-fullwidth"
                @click="getParcelDetail(marker)"
              >
                {{ $t("page.buttons.see") }}
              </button>
            </l-popup>
            <l-icon class-name="marker-icon">
              <img src="@/assets/marker.png" />
            </l-icon>
          </l-marker>
          <span v-for="parcel in parcels" :key="`parcel-${parcel.id}`">
            <l-geo-json
              ref="parcelLayer"
              :geojson="parcel.parcel.geo_data"
              :options="getStandOptions(0)"
              :optionsStyle="{
                color: '#575757',
                weight: 2,
                opacity: 0.5,
                fillColor: '#FFFFFF',
                fillOpacity: 0.4,
              }"
            />
            <l-geo-json
              v-for="(stand, index) in parcel.include_stands"
              :key="stand.id"
              :geojson="stand.geometry"
              :options="getStandOptions(index + 1)"
            />
          </span>
        </l-map>
      </div>
    </div>
  </div>
</template>

<script>
import {
  L,
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LGeoJson,
  LPopup,
  LControlLayers,
} from "vue2-leaflet"
import "leaflet/dist/leaflet.css"
import StandOptionsMixin from "@/mixins/StandOptionsMixin"
import api from "@/api"
import _ from "lodash"

export default {
  name: "ParcelsMap",
  mixins: [StandOptionsMixin],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LGeoJson,
    LPopup,
    LControlLayers,
  },
  beforeCreate() {
    // this part resolve an issue where the markers would not appear
    delete L.Icon.Default.prototype._getIconUrl
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    })
  },
  data() {
    return {
      tmsLayers: [
        {
          url: "https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg",
          visible: false,
          name: "IGN",
          attribution: "Topográfico - Instituto Geográfico Nacional",
        },
        {
          url: "https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg",
          visible: true,
          name: "Ortofoto",
          attribution: "PNOA - Instituto Geográfico Nacional",
        },
      ],
      options: { color: "#ffffff", fillOpacity: 0 },
      standOptions: { color: "#90B35B", fillColor: "#90B35B", fillOpacity: 0.5 },
      parcels: [],
      markers: [],
    }
  },
  mounted() {
    this.getParcels()
  },
  methods: {
    getParcels() {
      api.getParcels(1000).then((response) => {
        this.parcels = response.data.results
        this.setMarkers()
      })
    },
    setMarkers() {
      this.markers = this.$_.filter(this.parcels, (parcel) => {
        return this.$_.get(parcel, "parcel.geo_data.geometry", null)
      }).map((parcel) => {
        return {
          id: parcel.id,
          coords: L.geoJSON(parcel.parcel.geo_data).getBounds().getCenter(),
          title: _.get(parcel, "parcel.location", `'Parcela ${parcel.id}'`),
        }
      })

      const markersCollection = this.$_.map(this.markers, (marker) => {
        return L.marker(marker.coords)
      })

      this.$nextTick(() => {
        if (markersCollection) {
          this.$refs.map.setBounds(L.featureGroup(markersCollection).getBounds())
        }
      })
    },
    getParcelDetail(marker) {
      this.$router.push({ name: "parcel-detail", params: { id: marker.id } })
    },
  },
}
</script>
